module.exports = __webpack_public_path__ + "img/default2.018f8050.svg";